<template>
    <div v-if="!isMobile" class="productList">
        <div class="router">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{ $store.state.fast_category_name }}</el-breadcrumb-item>
                <el-breadcrumb-item> {{ langPage['catalogue-favoris-liste']['TXT_nouveautes'] }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <h3 class="title">{{ newProdCount }} {{ langPage['v4-nouveautes']['TXT_nouveautescettesemaine'] }}</h3>
        <div class="proBox" v-loading="loading">
            <div class="filter">
                <div style=" position: sticky;top: 0;z-index: 4;">
                    <goodsFilter :id="id" :filterList="filterList" :promotions="promotion"
                                 :support_categories_ids="support_categories_ids"
                                 @promos="promos" style=""></goodsFilter>
                    <!--                    <div class="coupon">-->
                    <!--                        <img src="../assets/img/vendeur/bg_1.png" alt/>-->
                    <!--                        <img src="../assets/img/vendeur/bg_2.png" alt/>-->
                    <!--                        <div>-->
                    <!--                            <span class="friday">{{remise_description}}</span>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
            </div>
            <div class="list">
                <div class="screen">
                    <div class="nav">
                        <div class="rows">
                            <img src="@/assets/img/productList/four_rows.png"
                                 v-if="rows == 3"
                                 alt
                                 @click="rows=4"/>
                            <img src="@/assets/img/productList/four_rows_act.png"
                                 v-if="rows == 4"
                                 alt
                                 @click="rows=4"/>
                        </div>
                        <div class="rows">
                            <img src="@/assets/img/productList/three_rows.png"
                                 v-if="rows == 4"
                                 alt
                                 @click="rows=3"/>
                            <img src="@/assets/img/productList/three_rows_act.png"
                                 v-if="rows == 3"
                                 alt
                                 @click="rows=3"/>
                        </div>
                    </div>
                    <div class="nav">
                        <div class="num">{{ count }} {{ langPage['compte-commandes-liste']['TXT_articles'] }}</div>
                        <div class="name">{{ langPage['catalogue-filtresrecherche']['TXT_trierpar'] }}</div>
                        <!--                        <div class="value"  @click="order == 'desc'?'asc':'desc'">Prix décroissants <i class="el-icon-arrow-down"></i></div>-->
                        <el-dropdown @command="handleCommand" style="min-width:80px">
                                <span class="el-dropdown-link">
                                    {{ order.value }}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :command="item"
                                    v-for="(item,index) in menuList"
                                    :key="index"
                                >{{ item.value }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="infinite-list"
                     v-infinite-scroll="loadMore"
                     infinite-scroll-disabled="busy"
                     infinite-scroll-distance="10"
                     infinite-scroll-throttle-delay="10">
                    <template v-if="list.length>0">
                        <goodsList ref="goodList" @goDetail="goDetail"
                                   @pagination="onLoadMoreClick"
                                   :total="count"
                                   :rows="rows" :list="list" type="0"
                                   :is_new_prod="true">
                        </goodsList>
<!--                        <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">-->
<!--                            <button-->
<!--                                @click="onLoadMoreClick"-->
<!--                                style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0"-->
<!--                            >{{ langPage['v4-nouveautes']['TXT_chargerplusdeproduites'] }}-->
<!--                            </button>-->
<!--                        </div>-->
                    </template>
                    <div v-else style="display: inline-flex;margin-left: 40%">
                        {{ langPage['boa-statistiques-catalogue-produits-liste']['TXT_aucunproduit'] }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="mproductList">
        <div class="router" v-if="id">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item class="breadcrumbItem" :to="{ path: '/' }">{{ id | routeName }}</el-breadcrumb-item>
                <el-breadcrumb-item class="breadcrumbItem">{{
                        langPage['mobile-produits']['TXT_nouveautes']
                    }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <h3 class="title">{{ newProdCount }} {{ langPage['v4-nouveautes']['TXT_nouveautescettesemaine'] }}</h3>

        <div class="container mobileCommon">
            <div class="proBox" v-loading="loading">
                <div class="list">
                    <div class="screen">
                        <div class="listTop">
                            <div class="num">{{ count }} {{
                                    langPage['produits-details-declinaison']['TXT_articles']
                                }}
                            </div>
                            <div class="imgLogo" style="text-align: left">
                                <div class="rows">
                                    <img src="@/assets/img/productList/two_rows.svg"
                                         v-if="rows == 1"
                                         alt
                                         @click="rows=2"/>
                                    <img src="@/assets/img/productList/two_rows_act.svg"
                                         v-if="rows == 2"
                                         alt
                                         @click="rows=2"/>
                                </div>
                                <div class="rows2">
                                    <img src="@/assets/img/productList/one_rows.svg"
                                         v-if="rows == 2"
                                         alt
                                         @click="rows=1"/>
                                    <img src="@/assets/img/productList/one_rows_act.svg"
                                         v-if="rows == 1"
                                         alt
                                         @click="rows=1"/>
                                </div>
                            </div>
                        </div>
                        <div class="listTop">
                            <div @click="is_show_filter=!is_show_filter" class="blackBtn leftBlackBtn">
                                <div align="center" style="font-size: 10pt">{{
                                        langPage['v4-productlist']['TXT_filtres']
                                    }}
                                </div>
                            </div>
                            <div class="nav" style="text-align: right">
                                <el-dropdown @command="handleCommand">
                                    <div class="sortContainer">
                                        <div class="el-dropdown-link sort" align="center">{{ order.value }}
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </div>
                                    </div>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="item"
                                            v-for="(item,index) in menuList"
                                            :key="index"
                                        >{{ item.value }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                    <div v-infinite-scroll="loadMore"
                         infinite-scroll-disabled="busy"
                         infinite-scroll-distance="10"
                         infinite-scroll-throttle-delay="10">
                        <template v-if="list.length>0">
                            <goodsList :style="{'margin-left': `${rows===1?'10vw':'5vw'}`}" ref="goodList"
                                       @goDetail="goDetail"
                                       @pagination="onLoadMoreClick"
                                       :total="count"
                                       :rows="rows"
                                       :list="list" type="0" :is_new_prod="true">
                            </goodsList>
<!--                            <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">-->
<!--                                <button-->
<!--                                    @click="onLoadMoreClick"-->
<!--                                    style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0;font-size: 10pt"-->
<!--                                >{{ langPage['v4-nouveautes']['TXT_chargerplusdeproduites'] }}-->
<!--                                </button>-->
<!--                            </div>-->
                        </template>
                        <div v-else style="display: inline-flex;margin-left: 40%">
                            {{ langPage['boa-statistiques-catalogue-produits-liste']['TXT_aucunproduit'] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--过滤器filter的抽屉-->
        <el-drawer
            :visible.sync="is_show_filter"
            direction="ltr"
            size="90%">
            <div class="drawerContainer">
                <div class="proBox" v-loading="loading">
                    <div class="filter">
                        <div style=" position: sticky;top: 0;z-index: 4;">
                            <goodsFilter :id="id" :id_vendeur="vid" :filterList="filterList" :promotions="promotion"
                                         :support_categories_ids="support_categories_ids"
                                         :marques="dataAll.vendeurs_marques"
                                         @chooseCategory="is_show_filter = false"
                                         @promos="promos" style=""></goodsFilter>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import goodsList from "../components/goodsList";
import goodsFilter from "../components/goodsFilter";
import bottomNav from "../components/bottomNav";
import vendeurHelper from "../utils/helper/vendeur/vendeur_helper";

let formatUtils = require('../utils/format');
let moment = require('moment');
export default {
    name: "ProductList",
    components: {
        goodsList,
        goodsFilter,
        bottomNav,
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            loading: false,
            menuList: [
                {key: "prix_asc", value: this.$store.state.langPage['catalogue-filtresrecherche']['TXT_prixcroissant']},//价格升顺
                {
                    key: "prix_desc",
                    value: this.$store.state.langPage['catalogue-filtresrecherche']['TXT_prixdecroissant']
                },//价格降序
                {key: "date_creation_asc", value: this.$store.state.langPage['v4-lastthing']['TXT_plusancien']},//创建时间升序
                {key: "date_creation_desc", value: this.$store.state.langPage['v4-lastthing']['TXT_plusrecent']}//创建时间降序
            ], //下拉框所有条件
            order: {key: "date_creation_desc", value: this.$store.state.langPage['v4-lastthing']['TXT_plusrecent']},//创建时间降序
            offset: 0,
            description: "", //商家描述
            currDiscount: [],//最近打折商品
            discountList: [], //折扣商品(对应有背景图的两个模块，如果这块数据没有直接渲染最近打折的商品)
            pages: 1,
            TotalCount: 0,
            busy: false,
            limit: 10,
            count: "", //一共多少个结果
            activeName: "0",
            show: false, //是否展示更多商家信息
            rows: 4,
            current: 1,
            list: [],
            topList: [],
            color: [],
            vid: "",
            id_categorie: this.$route.params.id,
            totleDate: [],
            promotion: [], //打折百分比,
            linksroute: [],
            dataAll: {},
            catalogues: [], //商家经营目录
            bgList: [
                require("../assets/img/home/bg04.svg"),
                require("../assets/img/home/ver_bg.png")
            ],
            filterList: {
                id_langue: localStorage.getItem("lang") || "fr", //语言
                vendu_par: "", //销售方式
                new: "", //是否为新品 1 0
                favoris: "", //是否为收藏
                reference: "", //货号
                prix_debut: "", //起始价格
                prix_fin: "", //最高价格
                promotion_debut: "", //打折最低价格
                promotion_fin: "", //打折最高价格
                provenances: [], //产地
                vendeurs: "", //商家
                marques: [], //品牌
                collections: [],
                promotions: [],
                compositions: [], //产品成分
                caracteristiques: [], //产品特性
                tendances: "", //品趋势
                couleurs: [], //产品颜色
                order: "date_creation_desc",
                categories: [] //产品类型
            },
            vendeur_contact_data: {},//商家的联系数据，包括facebook等
            support_categories_ids: [], //商家支持的最顶级的产品类型
            is_show_loadMore: true,
            remise_description: 'Pas de coupons disponibles', //优惠减价描述
            is_show_filter: false,
            query: this.$route.query,
            isLogin: !!this.$store.state.token,
            newProdCount: 0,
        }
    },
    computed: {
        id() {
            return parseInt(this.$route.params.id)
        },
        langPage() {
            return this.$store.state['langPage']
        }
    },
    filters: {
        routeName(para) {
            let str = ''
            switch (para) {
                case 11:
                    str = 'Femme'
                    break;
                case 12:
                    str = 'Homme'
                    break;
                case 13:
                    str = 'Enfant'
                    break;
                case 1401:
                    str = 'Chaussures'
                    break;
                case 15:
                    str = 'Sacs'
                    break;
                case 14:
                    str = 'Accessoires'
                    break;
                default:
                    str = 'Femme'
                    break;
            }
            return str
        },
        dateSubstring(value) {
            return value.slice(0, 10);
        },
        formatDate: formatUtils.parseTime
    },
    created() {
        this.filterList.id_langue = localStorage.getItem('lang') || 'fr'
        let para = this.$route.query.categories;
        if (para) {
            this.filterList.categories.push(para)
        }
    },
    mounted() {
        if (this.isMobile) {
            this.rows = 1;
        }
        this.loadMore();
        this.$common.EventBus.$on('loadmore', () => {
            this.offset = 0
            this.loadMore()
        });
        this.getOrderOrDeliverRemiseCode();
        this.getCategoryFilter();
        this.get_new_prod_count();
    },
    watch: {
        current(val) {
            console.log(val);
        },
        rows(val) {
        }
    },
    methods: {
        goDetail(item) {
            let url = window.origin + `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`
            window.open(url, '_blank');
        },
        promos(data) {
            if (data.length && data.length > 0) {
                this.filterList.promotion_debut = data[0].promotions_langues[0].promotion_debut,
                    this.filterList.promotion_fin = data[0].promotions_langues[0].promotion_fin
            } else {
                this.filterList.promotion_debut = '',
                    this.filterList.promotion_fin = ''
            }
            this.offset = 0
            this.loadMore()
        },
        loadMore(pageData) {
            // console.log(this.filterList)
            if (this.offset == this.pages) {
                return
            }
            this.busy = true
            this.offset = this.offset < this.pages ? this.offset += 1 : this.offset;
            this.getPList(pageData)
        },
        getPList(pageData = {
            page: 1,
            limit: this.$common.goodsListDefaultLimit,
        }) {
            let topDateList = [];
            this.loading = true;
            if (this.query.date_creation_debut) {
                this.filterList.date_creation_debut = this.query.date_creation_debut;
            } else {
                this.filterList.date_creation_debut = moment().add(-2, 'weeks').format('YYYY-MM-DD HH:mm:ss');
            }
            //未登录的时候加上分组查询实现一个商家只显示一个产品。
            if (!this.isLogin) this.filterList.groupBy = 'id_vendeur';
            this.$api.sort.getPList({
                ...this.filterList,
                limit: pageData.limit,
                page: pageData.page,
            }, this.id).then(res => {
                this.loading = false;
                this.is_show_loadMore = true;
                this.pages = res.pages;
                this.list = res.results
                // if (type != 'change') {
                //     this.list = this.list.concat(res.results);
                // } else {
                //     this.list = res.results
                // }
                this.count = res.count;
                // 设置连接地址是第一个颜色的链接地址
                for (var key in this.list) {
                    this.list[key].url = `${this.$common.imgHost}Images/Boutiques/${this.list[key].id_vendeur}/Produits/fiche/${this.list[key].id_produit}-c.jpg`;
                    for (var key1 in this.list[key].produit_liee) {
                        this.list[key].produit_liee[key1].url = `${this.$common.imgHost}Images/Boutiques/${this.list[key].produit_liee[key1].id_vendeur}/Produits/fiche/${this.list[key].produit_liee[key1].id_produit}-c.jpg`
                        if (key1 == 0) {
                            this.list[key].produit_liee[key1].clicked = true
                        } else {
                            this.list[key].produit_liee[key1].clicked = false
                        }
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        handleCommand(val) {
            this.order = val
            this.filterList.order = val.key
            this.list = [];
            this.topList = [];
            this.loadMore()
        },
        //当加载更多被点击了
        onLoadMoreClick(pageData) {
            this.is_show_loadMore = false;
            this.loadMore(pageData);
        },
        //获取产品的分类目录，给左边的过滤器使用
        getCategoryFilter() {
            try {
                let productListHelper = require('@/utils/helper/ProductList/productList_helper');
                this.support_categories_ids = productListHelper.getCategoryIds(this.$route.path, this.$store.state.categoriesIds);
            } catch (e) {
                console.log(e)
            }
        },
        //获取用户优惠券 订单或者物流优惠
        getOrderOrDeliverRemiseCode() {
            this.$api.info.getOrderOrDeliverRemiseCode().then(res => {
                if (res.code === 0) {
                    if (res.data.orderRemiseCode.length > 0) {
                        this.remise_description = vendeurHelper.getCouponDescription(res.data.orderRemiseCode[0]);
                    } else if (res.data.deliverRemiseCode.length > 0) {
                        this.remise_description = vendeurHelper.getCouponDescription(res.data.deliverRemiseCode[0]);
                    }
                }
            })
        },
        //获取新品数量
        async get_new_prod_count() {
            console.log('id_category',this.id_categorie)
            let res = await this.$api.good.get_new_prod_count({id_categorie: this.id_categorie});
            if (res.code != 0) return;
            this.newProdCount = res.data.count;
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Nouveautes.less">
</style>
